import { defineStore } from 'pinia';

// Store simple para mantener el id actual de la ruta
export const useRouteStore = defineStore('route', {
  state: () => ({
    currentId: null,
  }),
  actions: {
    setId(id) {
      // store string or number as given; normalize to number when needed elsewhere
      this.currentId = id;
    },
    clear() {
      this.currentId = null;
    }
  },
});

